import { SyncOutlined } from '@ant-design/icons';
import {
	Alert,
	Avatar,
	Button,
	Card,
	Col,
	Collapse,
	Form,
	Icon,
	Input,
	Modal,
	Radio,
	Row,
	Select,
	Spin,
	Tag,
	Tooltip,
	Typography,
} from 'antd';
import BaseComponent from 'components/BaseComponent';
import { DialogButton } from 'components/DialogIntegration';
import { MetaAccountSafety } from 'components/Meta/MetaAccountSafety';
import { MetaIntegration } from 'components/Meta/MetaIntegration';
import { ActiveConsumer } from 'contexts/legacy/ActiveContext';
import { LanguageConsumer } from 'contexts/legacy/LanguageContext';
import { NumberConsumer } from 'contexts/legacy/NumberContext';
import { SystemConsumer } from 'contexts/legacy/SystemContext';
import 'intl-tel-input/build/css/intlTelInput.css';
import { QRCodeCanvas } from 'qrcode.react';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import ReactIntlTelInput from 'react-intl-tel-input-v2';
import { dialogApi } from 'services/api';
import { getMetaConnectionState } from 'utils/metaConnectionState';
import message from '../../../../utils/messageWithScroll';
import { loadZApiConnectorSdk } from '../../../../utils/zapi/loadZApiConnectorSdk';
import { formItemLayout, intlTelOpts, useDeviceId, useNamespace, useQRCode } from './data';

const { Panel } = Collapse;
const { Option } = Select;

class AddEditNumberView extends BaseComponent {
	constructor(props) {
		super(props);
		this.state = {
			visible: props.state,
			disableApiField: false,
			country_value: { iso2: 'br', dialCode: '55', phone: '+55' },
			formNumber: {
				nickname: '',
				api: '',
				token: '',
				device_id: '',
				namespace: '',
				country_code: 'br',
				country_code_dial: '55',
				remove_cc: '0',
				number: '',
				status: '1',
				audio_transcription: '0',
				picture_url: '',
			},
			showDeviceId: false,
			showNamespace: false,
			showQRCode: false,
			sessionStarted: false,
			showContainerMsg: false,
			loadingQRCode: false,
			qrRead: false,
			profileInfo: {},
			qrcode: '',
			numberDisconnected: false,
			qrCodeError: false,
			loadingSdkConnector: false,
			sdkConnectorOpen: false,
			openaiTokenModified: false,
			showIntegration: false,
			loadingOpenAISettings: false,
			openaiRetryAttempt: 0,
		};
		this.startContainer = this.startContainer.bind(this);
		this.startSession = this.startSession.bind(this);
		this.deleteSession = this.deleteSession.bind(this);
		this.refreshSession = this.refreshSession.bind(this);
		this.updateQRCode = this.updateQRCode.bind(this);
		this.getSessionInfo = this.getSessionInfo.bind(this);
		this.qrReadTimeout = this.qrReadTimeout.bind(this);
		this.handleClick360Dialog = this.handleClick360Dialog.bind(this);
		this.qrRead = false;
		this.updateQRCodeID = 0;
		this.getSessionInfoID = 0;
		this.startSessionID = 0;
		// Travas de "no máximo um toast por sessão de modal" para os eventos `error`/`status`
		// do SDK Connector — resetadas a cada chamada de `openSdkConnector`. Sem isso o toast de
		// `error` spammaria a tela, já que o SDK re-tenta o QR a cada ~2s e emite `error` a cada
		// falha (ver `epico.md`, subtask B3).
		this.sdkConnectorErrorToastShown = false;
		this.sdkConnectorExpiredToastShown = false;
	}

	componentWillUnmount() {
		// Não havia nenhum `componentWillUnmount` neste componente antes do SDK Connector —
		// aproveita para também limpar os intervals de polling do QR Code, que continuariam
		// rodando (e chamando `setState` num componente desmontado) caso o modal seja fechado
		// sem o usuário clicar em "Cancelar".
		clearInterval(this.updateQRCodeID);
		clearInterval(this.getSessionInfoID);
		clearInterval(this.startSessionID);
		// Remove os listeners do SDK Connector caso o componente seja desmontado com o modal
		// ainda aberto (`open()` fica pendente até o usuário fechá-lo, o que pode levar minutos).
		this.detachSdkConnectorListeners();
	}

	loadOpenAISettings = async () => {
		if (this.props.formNumber?.id && this.props.formNumber?.number) {
			await this.promisedSetState({
				loadingOpenAISettings: true,
				openaiRetryAttempt: 0,
			});

			const maxRetries = 3;
			const retryDelay = 1000;
			let lastError = null;

			for (let attempt = 1; attempt <= maxRetries; attempt++) {
				try {
					await this.promisedSetState({ openaiRetryAttempt: attempt });

					const openaiSettings = await this.props.number.getNumberSettings(
						this.props.formNumber.number,
					);

					await this.promisedSetState({
						formNumber: {
							...this.state.formNumber,
							openai_token: openaiSettings.maskedToken || '',
							audio_transcription: openaiSettings.audioTranscription ? '1' : '0',
						},
					});

					break;
				} catch (error) {
					lastError = error;

					if (attempt < maxRetries) {
						await new Promise((resolve) => setTimeout(resolve, retryDelay));
					}
				}
			}

			if (lastError) {
				await this.promisedSetState({
					formNumber: {
						...this.state.formNumber,
						openai_token: '',
					},
				});
			}

			await this.promisedSetState({
				loadingOpenAISettings: false,
				openaiRetryAttempt: 0,
			});
		}
	};

	async componentDidMount() {
		const { language } = this.props.language;

		if (this.props.preSelectedAPI) {
			await this.promisedSetState({
				formNumber: {
					...this.state.formNumber,
					api: this.props.preSelectedAPI,
				},
			});
			await this.promisedSetState({ disableApiField: true });
			if (!this.props.formNumber) {
				await this.onApiChange(this.props.preSelectedAPI);
			}
		}

		await this.getSessionInfo();
		if (this.props.formNumber) {
			await this.promisedSetState({ formNumber: this.props.formNumber });

			this.loadOpenAISettings();

			await this.promisedSetState({
				country_value: {
					iso2: this.props.formNumber.country_code,
					dialCode: this.props.formNumber.country_code_dial,
					phone: '+' + this.props.formNumber.country_code_dial,
				},
			});
			await this.promisedSetState({
				showDeviceId: useDeviceId.indexOf(this.props.formNumber.api) > -1,
			});
			await this.promisedSetState({
				showNamespace: useNamespace.indexOf(this.props.formNumber.api) > -1,
			});
			await this.promisedSetState({
				showQRCode: useQRCode.includes(this.props.formNumber.api),
			});
			await this.promisedSetState({
				disableApiField: useQRCode.includes(this.props.formNumber.api) || this.isEditDialogNumber(),
			});
			if (useQRCode.includes(this.props.formNumber.api)) {
				if (this.props.formNumber.blocked) {
					message.error(
						<div style={{ display: 'inline' }}>
							{language.blocked_number_alert_1}
							{this.props.formNumber.nickname} - {this.props.formNumber.number}{' '}
							{language.blocked_number_alert_2}
							<a
								href="https://ajuda.br24.io/?utm_source=powerzap&utm_medium=boas-praticas&utm_campaign=banimento"
								target="_blank"
								rel="noreferrer"
							>
								{language.best_practices_manual}
							</a>
							{language.blocked_number_alert_3}
						</div>,
					);
					return;
				}

				if (!this.props.formNumber.sessionInfo.status) {
					message.error(
						`${language.number_disconnected_alert} "${this.state.formNumber.nickname}"`,
					);
					return;
				}

				this.qrRead = true;
				await this.promisedSetState({ qrRead: true });
			}
		}
	}

	async componentDidUpdate(prevProps) {
		const isQrCodeApi = useQRCode.includes(this.state.formNumber.api);
		const isVisible = this.props.visible && !prevProps.visible;
		if (isVisible && isQrCodeApi) {
			// Este componente não desmonta ao fechar o modal (fica com `visible=false`, ver
			// `NumberItem`), então sem este reset uma sessão anterior com `qrCodeError: true`
			// (>=3 falhas consecutivas de polling) reabriria o modal já mostrando o card de
			// "falha ao atualizar" antes mesmo do primeiro poll desta nova sessão — mesmo reset
			// já feito em `reloadQRCode` para o caminho de "Tentar novamente".
			this.qrCodeFailureCount = 0;
			await this.promisedSetState({ qrCodeError: false });
			this.updateQRCodeID = setInterval(this.updateQRCode, 18000);
			this.getSessionInfoID = setInterval(this.getSessionInfo, 5000);
			await this.updateQRCode();
			const self = this;
			setTimeout(function () {
				self.qrReadTimeout();
			}, 240000);
		}

		if (isVisible && this.props.formNumber?.api === 'meta' && !!this.props.formNumber?.id) {
			this.setState({ showIntegration: false, formNumber: this.props.formNumber });
			this.props.number.getNumbersStatus([this.props.formNumber], true);
		}

		if (
			this.props.visible &&
			!prevProps.visible &&
			this.props.formNumber?.id &&
			this.props.formNumber?.number
		) {
			const cachedSettings = await this.props.number.getNumberSettings(
				this.props.formNumber.number,
			);
			if (cachedSettings) {
				await this.promisedSetState({
					formNumber: {
						...this.state.formNumber,
						audio_transcription: cachedSettings.audioTranscription ? '1' : '0',
						openai_token: cachedSettings.maskedToken || this.state.formNumber.openai_token || '',
					},
				});
			}
		}
	}

	startContainer = async (formNumber) => {
		const { number } = this.props;
		const { language } = this.props.language;

		try {
			const startContainerResult = await number.startContainer(formNumber);
			if (!startContainerResult.status) {
				message.error(startContainerResult.message);
				return;
			}

			await this.promisedSetState({
				formNumber: {
					...this.state.formNumber,
					token: startContainerResult.token,
					device_id: startContainerResult.device_id,
					namespace: startContainerResult.namespace,
				},
			});

			await this.getQRCode();
			this.startSessionID = setInterval(this.getQRCode, 60000);

			setTimeout(function () {
				clearInterval(this.startSessionID);
				message.error('Failed to start Container');
			}, 1200000);
		} catch (e) {
			message.error(language.start_session_failed + ' ' + e);
		}
	};

	startSession = async (formNumber) => {
		const { number } = this.props;
		const { language } = this.props.language;

		if (!formNumber.token) {
			const result = await number.startContainer(formNumber);

			if (result.status) {
				await this.promisedSetState({
					formNumber: {
						...this.state.formNumber,
						token: result.token,
						device_id: result.device_id,
						namespace: result.namespace,
					},
				});
			}

			try {
				const numberStartSessionResult = await number.startSession(this.state.formNumber);
				if (numberStartSessionResult.status) {
					await this.promisedSetState({ sessionStarted: true });
					clearInterval(this.startSessionID);
				}
				return numberStartSessionResult;
			} catch (e) {
				message.error(`${language.start_session_failed} ${e}`);
			}
		}
	};

	deleteSession = async () => {
		const { number } = this.props;
		const { language } = this.props.language;

		try {
			clearInterval(this.getSessionInfoID);
			clearInterval(this.updateQRCodeID);

			const numberDeleteSessionResult = await number.deleteSession(this.state.formNumber);
			if (numberDeleteSessionResult.status) {
				this.qrRead = false;
				this.qrCodeFailureCount = 0;
				await this.promisedSetState({
					sessionStarted: false,
					loadingQRCode: false,
					numberDisconnected: false,
					qrRead: false,
					profileInfo: {},
					qrcode: '',
					qrCodeError: false,
				});
			}
		} catch (e) {
			message.error(`${language.start_session_failed} ${e}`);
		}
	};

	refreshSession = async () => {
		const { number } = this.props;
		const { language } = this.props.language;

		try {
			clearInterval(this.getSessionInfoID);
			clearInterval(this.updateQRCodeID);

			const numberDeleteSessionResult = await number.deleteSession(this.state.formNumber);

			if (numberDeleteSessionResult.status) {
				this.qrRead = false;
				this.qrCodeFailureCount = 0;
				await this.promisedSetState({
					sessionStarted: false,
					numberDisconnected: false,
					qrRead: false,
					profileInfo: {},
					qrCodeError: false,
				});
			}
		} catch (e) {
			message.error(`${language.start_session_failed} ${e}`);
		}
	};
	// Função debounce para garantir que não dispare múltiplas vezes em sequencia
	debounce(func, delay) {
		let timer;
		return function (...args) {
			if (timer) clearTimeout(timer);
			timer = setTimeout(() => func.apply(this, args), delay);
		};
	}

	updateQRCode = async () => {
		if (this.qrRead) {
			return;
		}

		if (!this.state.loadingQRCode) {
			await this.promisedSetState({ loadingQRCode: true });
		}

		try {
			const QRCodeResult = await this.props.number.getQRCode(this.state.formNumber);

			if (QRCodeResult.status) {
				// Sucesso zera a contagem — o contador deve refletir falhas *consecutivas*,
				// não o total de polls realizados.
				this.qrCodeFailureCount = 0;
				await this.promisedSetState({
					qrcode: QRCodeResult.qrCode,
					numberDisconnected: false,
					qrCodeError: false,
				});
				return;
			}

			this.qrCodeFailureCount = (this.qrCodeFailureCount || 0) + 1;
			console.error('updateQRCode failed', QRCodeResult.error);

			if (this.qrCodeFailureCount >= 3) {
				// Substitui o antigo "toast + para o polling silenciosamente" por um estado
				// visual persistente (renderQRCodeContent), com o CTA do método alternativo.
				clearInterval(this.updateQRCodeID);
				clearInterval(this.getSessionInfoID);
				await this.promisedSetState({ qrcode: QRCodeResult.qrCode, qrCodeError: true });
			}
		} catch (error) {
			// Uma exceção de rede também é uma falha de poll e deve contar para a mesma
			// sequência de falhas consecutivas do caminho `!QRCodeResult.status`.
			this.qrCodeFailureCount = (this.qrCodeFailureCount || 0) + 1;
			console.error('Error updating QR Code:', error);

			if (this.qrCodeFailureCount >= 3) {
				clearInterval(this.updateQRCodeID);
				clearInterval(this.getSessionInfoID);
				await this.promisedSetState({ qrCodeError: true });
			}
		} finally {
			await this.promisedSetState({ loadingQRCode: false });
		}
	};

	reloadQRCode = this.debounce(async () => {
		clearInterval(this.updateQRCodeID);
		clearInterval(this.getSessionInfoID);

		this.qrCodeFailureCount = 0;
		await this.promisedSetState({ qrCodeError: false });
		this.updateQRCodeID = setInterval(this.updateQRCode, 18000);
		this.getSessionInfoID = setInterval(this.getSessionInfo, 5000);

		await this.updateQRCode();
		const self = this;

		setTimeout(function () {
			self.qrReadTimeout();
		}, 240000);
	}, 1000);

	getSessionInfo = async () => {
		if (!this.qrRead && this.props.visible) {
			try {
				const sessionInfoResult = await this.props.number.getSessionInfo(this.state.formNumber);

				if (sessionInfoResult.status) {
					this.qrRead = true;
					clearInterval(this.updateQRCodeID);
					clearInterval(this.getSessionInfoID);

					await this.promisedSetState({ profileInfo: sessionInfoResult.info });
					await this.promisedSetState({ qrRead: true });
					await this.promisedSetState({
						formNumber: {
							...this.state.formNumber,
							number: sessionInfoResult.info.clientNumber,
							nickname: this.state.formNumber.nickname || sessionInfoResult.info.name,
							sessionInfo: {
								...this.state.formNumber.sessionInfo,
								status: true,
								imgUrl: sessionInfoResult.imgUrl || sessionInfoResult.info.profilePicUrl,
								phone: sessionInfoResult.info.clientNumber,
								name: sessionInfoResult.info.name,
								info: sessionInfoResult.info,
							},
						},
					});

					const result = await this.props.number.addEditNumber(this.state.formNumber);
					await this.promisedSetState({
						formNumber: { ...this.state.formNumber, id: result.dados },
					});
				}
			} catch (error) {
				message.error(error.msg || language.add_number_error);
				clearInterval(this.updateQRCodeID);
				clearInterval(this.getSessionInfoID);
			}
		}
	};

	qrReadTimeout = async () => {
		if (!this.qrRead) {
			await this.promisedSetState({ numberDisconnected: true });
			if (this.state.sessionStarted) {
				await this.deleteSession();
			}
		}
	};

	// Mapeia o idioma escolhido pelo usuário no app (br/en/la) para o `locale` nativo do SDK
	// (pt/en) — o SDK, se omitido, auto-detecta a partir de `navigator.language`, que pode
	// divergir do idioma selecionado na tela. O SDK não tem espanhol nativo, então `la` cai
	// em `en` como fallback documentado.
	mapLanguageToSdkLocale = (lang) => {
		if (lang === 'br') return 'pt';
		return 'en';
	};

	// Handlers dos eventos do SDK Connector (`on`/`off`), conforme a referência oficial
	// (seção "Events"): https://developer.z-api.io/en/partner/sdk-connector#events.
	// Guardados como métodos de instância vinculados (não funções inline em `openSdkConnector`)
	// para que a mesma referência de função seja usada tanto em `on` quanto em `off`.
	handleSdkConnectorError = () => {
		const { language } = this.props.language;

		// No máximo um toast de erro por sessão do modal: o SDK re-tenta o QR a cada ~2s e
		// emite `error` a cada falha, então sem essa trava o toast spammaria a tela.
		if (this.sdkConnectorErrorToastShown) {
			return;
		}
		this.sdkConnectorErrorToastShown = true;
		message.error(language.zapi_alternative_method_sdk_error);
	};

	handleSdkConnectorStatus = (payload) => {
		const { language } = this.props.language;
		const status = payload?.status;

		// `status` também reporta "qr"/"connected"/"disconnected", que não geram toast aqui
		// (cobertos pelo retorno de `open()` ao fechar o modal) — só "expired" é tratado, e
		// também no máximo uma vez por sessão do modal.
		if (status !== 'expired' || this.sdkConnectorExpiredToastShown) {
			return;
		}
		this.sdkConnectorExpiredToastShown = true;
		message.error(language.zapi_alternative_method_expired);
	};

	// Remove os listeners registrados em `openSdkConnector` — chamado tanto ao final da sessão
	// do modal (`open()` resolvido/rejeitado) quanto em `componentWillUnmount`, caso o
	// componente seja desmontado com o modal ainda aberto.
	detachSdkConnectorListeners = () => {
		if (!window.ZAPIConnector?.off) {
			return;
		}
		window.ZAPIConnector.off('error', this.handleSdkConnectorError);
		window.ZAPIConnector.off('status', this.handleSdkConnectorStatus);
	};

	// Método alternativo ao QR Code: carrega o Connection SDK da Z-API (B1), busca o token de
	// sessão de curta duração (A2) e abre o modal do SDK — conforme
	// https://developer.z-api.io/en/partner/sdk-connector.
	openSdkConnector = async () => {
		const { language } = this.props.language;

		if (this.state.loadingSdkConnector || this.state.sdkConnectorOpen) {
			return;
		}

		// A instância só existe (e só tem token) depois do startContainer/startSession, que pode
		// levar minutos — sem isso a URL do endpoint fica malformada (token vazio).
		if (!this.state.formNumber.token) {
			message.error(language.zapi_alternative_method_not_ready);
			return;
		}

		await this.promisedSetState({ loadingSdkConnector: true });

		// Reseta as travas de "no máximo um toast por sessão" a cada nova tentativa de abrir o
		// modal — uma instância pode expirar/errar em uma sessão e ser aberta novamente depois.
		this.sdkConnectorErrorToastShown = false;
		this.sdkConnectorExpiredToastShown = false;

		try {
			await loadZApiConnectorSdk();

			const tokenResult = await this.props.number.getSdkConnectorToken(this.state.formNumber);
			if (!tokenResult?.status || !tokenResult?.token) {
				message.error(language.zapi_alternative_method_error);
				return;
			}

			// O spinner do CTA deve cobrir só a busca do token/carregamento do SDK — não a sessão
			// inteira do modal, que só resolve quando o usuário o fecha (podendo levar minutos).
			// `sdkConnectorOpen` assume o guard de reentrância enquanto o modal estiver aberto.
			await this.promisedSetState({ loadingSdkConnector: false, sdkConnectorOpen: true });

			// Garante que o iframe do Bitrix24 esteja com a altura ajustada antes de um modal
			// `position: fixed` ser montado em document.body — caso contrário o overlay se
			// posiciona relativo ao viewport do iframe e pode abrir fora da área visível.
			window.BX24?.fitWindow?.();

			// `error`/`status===expired` dão feedback intermediário enquanto o modal está aberto
			// (ex.: instância expirada, falha de rede no meio da tentativa); `connected`/`close`/
			// `qr` não geram toast aqui para não duplicar o feedback já dado pelo retorno de
			// `open()` logo abaixo.
			window.ZAPIConnector.on('error', this.handleSdkConnectorError);
			window.ZAPIConnector.on('status', this.handleSdkConnectorStatus);

			let connected = false;
			try {
				connected = await window.ZAPIConnector.open({
					token: tokenResult.token,
					locale: this.mapLanguageToSdkLocale(this.props.language.lang),
				});
			} finally {
				this.detachSdkConnectorListeners();
			}

			if (connected === true) {
				// Conectou pelo SDK: evita um getQRCode desnecessário contra uma instância já
				// conectada e evita re-armar o timeout de 240s do reloadQRCode, que poderia
				// derrubar essa conexão recém-estabelecida caso o getSessionInfo não confirme a
				// tempo. Toast é só informativo — o status real (`connected`) ainda vem do
				// socket existente (`channel-connection-update`), alimentado pelo webhook
				// `zapi/connected`.
				message.success(language.zapi_alternative_method_connected);
				await this.promisedSetState({ qrCodeError: false });
				await this.getSessionInfo();
				return;
			}

			// Usuário fechou o modal sem conectar — feedback de cancelamento e retoma o
			// polling normal do QR Code.
			message.info(language.zapi_alternative_method_cancelled);
			this.reloadQRCode();
		} catch (error) {
			console.error('Error opening Z-API SDK Connector:', error);
			message.error(language.zapi_alternative_method_error);
		} finally {
			this.detachSdkConnectorListeners();
			await this.promisedSetState({ loadingSdkConnector: false, sdkConnectorOpen: false });
		}
	};

	getQRCode = async () => {
		const { number } = this.props;
		const { language } = this.props.language;

		if (!this.state.sessionStarted && this.props.visible) {
			await this.promisedSetState({ showContainerMsg: true });
			const startSessionResult = await this.startSession(this.state.formNumber);

			if (!startSessionResult.status && !this.state.showContainerMsg) return;

			await this.promisedSetState({ showContainerMsg: false });
			await window.BX24.callMethod('im.notify', {
				to: number.user.ID,
				message: language.session_start_alert,
			});
		}

		if (!this.updateQRCodeID) {
			this.updateQRCodeID = setInterval(this.updateQRCode, 18000);
			this.getSessionInfoID = setInterval(this.getSessionInfo, 5000);
			await this.updateQRCode();
			const self = this;
			setTimeout(function () {
				self.qrReadTimeout();
			}, 240000);
		}
	};

	onApiChange = async (value) => {
		await this.promisedSetState({
			formNumber: { ...this.state.formNumber, api: value },
			showDeviceId: useDeviceId.indexOf(value) > -1,
			showNamespace: useNamespace.indexOf(value) > -1,
			showQRCode: useQRCode.includes(value),
		});

		if (useQRCode.includes(value)) {
			await this.promisedSetState({
				formNumber: { ...this.state.formNumber, token: '' },
			});
			await this.getQRCode();
		}
	};

	onChange = async (value) => {
		await this.promisedSetState({
			country_value: { ...value, phone: '+' + value.dialCode },
			formNumber: {
				...this.state.formNumber,
				country_code: value.iso2,
				country_code_dial: value.dialCode,
			},
		});
	};

	submitDialogSandbox = async (formNumber) => {
		const simulatedEventData = {
			id: 'sandbox',
			event: 'channel_permission_granted',
			data: {
				id: 'sandbox',
				client_id: 'sandbox',
				setup_info: {
					phone_number: formNumber.number,
					phone_name: formNumber.nickname,
				},
				client: {
					contact_info: {
						country: formNumber.country_code,
					},
				},
				waba_account: {
					id: 'sandbox',
					namespace: 'sandbox',
				},
				token: formNumber.token,
			},
		};

		await dialogApi.post('/webhook', simulatedEventData);
		return await dialogApi.get(`/finish?domain=${this.props.number.infos.domain}&client=sandbox`);
	};

	handleSubmit = async (e) => {
		if (this.isAddDialogNumber()) return this.props.okAction();
		const { formNumber } = this.state;
		const { language } = this.props.language;

		const audioTranscriptionEnabled = String(formNumber.audio_transcription) === '1';
		if (audioTranscriptionEnabled) {
			const hasToken = formNumber.openai_token?.trim();
			const isMaskedFromBackend =
				hasToken && /^sk(-proj)?-[a-zA-Z0-9]{6}\.\.\.[a-zA-Z0-9]{4}$/.test(hasToken);

			if (!isMaskedFromBackend) {
				if (!hasToken) {
					return message.error(language.openai_token_required);
				}

				const validation = this.validateOpenAIToken(formNumber.openai_token);
				if (!validation.isValid) {
					return message.error(validation.message);
				}
			}
		}

		try {
			await this.props.active.createCustomer(formNumber.api);

			if (!formNumber.number) throw language.number_empty;
			if (!formNumber.token) throw language.token_empty;
			if (!formNumber.api) throw language.api_empty;
			if (useDeviceId.includes(formNumber.api) && !formNumber.device_id)
				throw language.device_id_empty;
			if (useNamespace.includes(formNumber.api) && !formNumber.namespace)
				throw language.namespace_empty;

			const { getListOfNumbers, getListCampaigns, getConnectedChannels } = this.props.number;

			await this.props.number.addEditNumber(formNumber);

			try {
				const isMaskedFromBackend = /^sk(-proj)?-[a-zA-Z0-9]{6}\.\.\.[a-zA-Z0-9]{4}$/.test(
					formNumber.openai_token || '',
				);
				const audioTranscriptionEnabled = String(formNumber.audio_transcription) === '1';
				const shouldUpdateToken = formNumber.openai_token?.trim() && !isMaskedFromBackend;
				await this.props.number.saveNumberSettings(
					shouldUpdateToken ? formNumber.openai_token : null,
					formNumber.number,
					audioTranscriptionEnabled,
				);
			} catch (openaiError) {
				console.log('Error saving OpenAI settings:', openaiError);
				message.warning(language.msg_error_openai_token);
			}

			message.success(formNumber.id ? language.edit_number_success : language.add_number_success);

			await getListOfNumbers();
			await getListCampaigns();
			await getConnectedChannels();

			this.props.okAction();
		} catch (e) {
			try {
				await this.props.number.getListOfNumbers();
			} catch (refreshError) {
				console.warn('Falha ao atualizar lista de números após erro no submit:', refreshError);
			}

			if (!this.isEmptyApi()) {
				return message.error(e.msg || language.add_number_error);
			}

			message.error(language.add_number_api_empty);
		}
	};

	isEmptyApi = () => {
		return this.state.formNumber.api === '';
	};

	isAddDialogNumber = () => {
		return this.state.formNumber.api === 'dialog' && !this.state.formNumber.id;
	};

	isAddMetaNumber = () => {
		return this.state.formNumber.api === 'meta';
	};

	metaConnectionState = () => {
		return getMetaConnectionState(this.state.formNumber, this.props.formNumber);
	};

	isEditDialogNumber = () => {
		return this.state.formNumber.api === 'dialog' && this.state.formNumber.id;
	};

	onCancel = async () => {
		return this.props.cancelAction();
	};

	onOk = async () => {
		const { formNumber } = this.state;
		const { language } = this.props.language;

		if (!formNumber.nickname || formNumber.nickname.trim() === '') {
			message.error(language.nickname_required);
			return;
		}
		if (this.isAddDialogNumber()) return this.props.cancelAction();
		return this.props.system.expired && !this.props.number.creationLimit
			? this.props.cancelAction()
			: this.handleSubmit();
	};

	isOkDisabled = () => {
		return this.props.system.expired ||
			(this.props.number.creationLimit && this.state.formNumber.id)
			? false
			: !!(this.props.number.creationLimit && this.state.formNumber.id === undefined);
	};

	handleClick360Dialog = () => {
		this.props.setActiveTabKey('6');
		this.props.setActiveTabTutorialKey('3');
		this.onCancel();
	};

	handleMetaFinish = (updatedFormNumber) => {
		this.setState({ formNumber: updatedFormNumber }, () => {
			this.handleSubmit();
		});
	};

	validateOpenAIToken = (token) => {
		const { language } = this.props.language;
		const trimmedToken = token?.trim();
		if (!trimmedToken || trimmedToken === '') {
			return {
				isValid: false,
				message: language.openai_token_required,
			};
		}

		const isMaskedFromBackend = /^sk(-proj)?-[a-zA-Z0-9]{6}\.\.\.[a-zA-Z0-9]{4}$/.test(
			trimmedToken,
		);
		if (!isMaskedFromBackend) {
			const isValidFormat = /^sk(-proj)?-[a-zA-Z0-9_-]{48,}$/.test(trimmedToken);
			if (!isValidFormat) {
				return {
					isValid: false,
					message: language.openai_token_invalid,
				};
			}
		}

		return { isValid: true };
	};

	handleAudioTranscriptionChange = (value) => {
		this.setState({
			formNumber: {
				...this.state.formNumber,
				audio_transcription: value,
			},
		});
	};

	renderQRCodeSection = () => {
		if (!this.state.qrRead) {
			return this.renderQRCodeDisplay();
		}
		return this.renderProfileDisplay();
	};

	renderQRCodeDisplay = () => {
		return (
			<Card
				bordered
				style={{
					borderRadius: '8px',
					backgroundColor: '#fafafa',
					margin: '10px 0',
				}}
			>
				<Row justify="center" style={{ textAlign: 'center' }}>
					<Col span={24}>{this.renderQRCodeContent()}</Col>
					<Col span={24}>{this.renderSdkConnectorCta()}</Col>
				</Row>
			</Card>
		);
	};

	// CTA "Problemas para conectar? Use o método alternativo" — sempre visível enquanto o
	// número não estiver conectado (renderQRCodeDisplay só é chamado nesse caso), não somente
	// depois de uma falha, conforme critério de aceite da subtask.
	// Específico do Connection SDK da Z-API: `useQRCode` também inclui `powerzap`, que não tem
	// esse método alternativo, então o CTA precisa ficar oculto para qualquer outra API.
	renderSdkConnectorCta = () => {
		if (this.state.formNumber.api !== 'zapi') {
			return null;
		}

		const instanceReady = !!this.state.formNumber.token && !this.state.showContainerMsg;

		return (
			<Button
				type="link"
				loading={this.state.loadingSdkConnector}
				disabled={this.state.loadingSdkConnector || !instanceReady}
				onClick={this.openSdkConnector}
				style={{ paddingTop: 0 }}
			>
				<FormattedMessage id="zapi_alternative_method_cta" />
			</Button>
		);
	};

	renderQRCodeContent = () => {
		// `numberDisconnected` é um estado mais terminal que uma falha de polling do QR Code —
		// checar primeiro evita que o card de "falha ao atualizar" fique preso na tela e esconda
		// o estado real de "número desconectado" depois de um deleteSession/refreshSession.
		if (this.state.numberDisconnected) {
			return (
				<div
					style={{
						position: 'relative',
						minHeight: '280px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexDirection: 'column',
						gap: '20px',
					}}
				>
					<Tag color="red" style={{ fontSize: '14px' }}>
						<FormattedMessage id="number_disconnected" />
					</Tag>
					{this.renderRefreshButton() && (
						<div
							style={{
								padding: '12px',
								backgroundColor: '#ffffff',
								borderRadius: '50%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
							}}
						>
							{this.renderRefreshButton()}
						</div>
					)}
				</div>
			);
		}

		if (this.state.qrCodeError) {
			return (
				<div
					style={{
						position: 'relative',
						minHeight: '280px',
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						flexDirection: 'column',
						gap: '16px',
						padding: '0 16px',
					}}
				>
					<Tag color="orange" style={{ fontSize: '14px' }}>
						<FormattedMessage id="qrcode_polling_failed" />
					</Tag>
					<Typography style={{ fontSize: '13px', color: 'rgba(0, 0, 0, 0.65)' }}>
						<FormattedMessage id="qrcode_polling_failed_message" />
					</Typography>
					{this.renderRefreshButton() && (
						<div
							style={{
								padding: '12px',
								backgroundColor: '#ffffff',
								borderRadius: '50%',
								display: 'flex',
								justifyContent: 'center',
								alignItems: 'center',
								boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
							}}
						>
							{this.renderRefreshButton()}
						</div>
					)}
				</div>
			);
		}

		return (
			<div style={{ position: 'relative', display: 'inline-block' }}>
				{this.renderQRCodeMessage()}
				<Spin spinning={this.state.qrcode === '' && !this.state.loadingQRCode} size="large">
					<div style={{ position: 'relative' }}>
						<QRCodeCanvas
							value={this.state.qrcode}
							size={256}
							bgColor="#ffffff"
							fgColor="#000000"
						/>
						{this.renderRefreshButton() && (
							<div
								style={{
									position: 'absolute',
									top: '50%',
									left: '50%',
									transform: 'translate(-50%, -50%)',
									padding: '8px',
									backgroundColor: '#ffffff',
									borderRadius: '50%',
									display: 'flex',
									justifyContent: 'center',
									alignItems: 'center',
									boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
								}}
							>
								{this.renderRefreshButton()}
							</div>
						)}
					</div>
				</Spin>
			</div>
		);
	};

	renderQRCodeMessage = () => {
		if (this.state.showContainerMsg) {
			return (
				<Typography color="blue" style={{ fontSize: '14px', paddingBottom: 10 }}>
					<FormattedMessage id="starting_container" />
				</Typography>
			);
		}

		if (this.state.qrcode) {
			return (
				<Typography color="blue" style={{ fontSize: '14px', paddingBottom: 10 }}>
					<FormattedMessage id="reading_qrcode_message" />
				</Typography>
			);
		}

		return null;
	};

	renderRefreshButton = () => {
		if (this.state.showContainerMsg) {
			return null;
		}

		return (
			<Button
				type="primary"
				shape="circle"
				size="large"
				disabled={this.state.loadingQRCode}
				className="pt-1"
				onClick={async () => {
					await this.promisedSetState({ loadingQRCode: true });
					await this.refreshSession();
					this.reloadQRCode();
				}}
			>
				<SyncOutlined
					style={{ fontSize: '20px', height: '20px' }}
					spin={this.state.loadingQRCode}
				/>
			</Button>
		);
	};

	renderProfileDisplay = () => {
		return (
			<div
				style={{
					borderRadius: '8px',
					backgroundColor: '#fafafa',
					margin: '10px 0',
					overflow: 'hidden',
				}}
			>
				<div
					style={{
						backgroundColor: '#f6ffed',
						color: '#52c41a',
						border: '1px solid #b7eb8f',
						textAlign: 'center',
						padding: '6px 16px',
						fontSize: '14px',
						borderRadius: '8px 8px 0 0',
						margin: 0,
					}}
				>
					<FormattedMessage id="connected_number" defaultMessage="Connected number:" />{' '}
					<span style={{ fontWeight: 'bold' }}>{this.props.formNumber?.number}</span>
				</div>
				<Card
					bordered={false}
					bodyStyle={{ padding: 0 }}
					style={{
						borderRadius: 0,
						backgroundColor: '#fafafa',
						margin: 0,
						border: '1px solid #d9d9d9',
						borderTop: 'none',
						borderBottom: 'none',
					}}
				>
					<div style={{ padding: '24px 24px 24px 24px' }}>
						<Row justify="center" style={{ textAlign: 'center' }}>
							<Avatar
								size={256}
								src={
									this.state.formNumber?.sessionInfo?.imgUrl ||
									this.props.formNumber?.sessionInfo?.imgUrl
								}
							/>
						</Row>
					</div>
				</Card>
				<Button
					type="danger"
					size="large"
					loading={this.state.loadingQRCode}
					block
					style={{
						borderRadius: '0 0 8px 8px',
						height: '40px',
						fontSize: '14px',
						fontWeight: 'bold',
						border: 'none',
						margin: 0,
						boxShadow: 'none',
					}}
					onClick={async () => {
						await this.promisedSetState({ loadingQRCode: true });
						await this.refreshSession();
						this.reloadQRCode();
					}}
				>
					<FormattedMessage id="disconnect" defaultMessage="Desconectar" />
				</Button>
			</div>
		);
	};

	renderPhoneNumberInput = () => {
		const { getFieldDecorator } = this.props.form;

		return (
			<Form.Item style={{ marginBottom: 0 }}>
				{getFieldDecorator('phone_number', {
					rules: [
						{
							required: false,
							message: <FormattedMessage id="form_msg_phone_number" />,
						},
					],
				})(
					<FormattedMessage id="phone_number">
						{(msg) => (
							<Input
								prefix={<Icon type="mobile" style={{ color: 'rgba(0,0,0,.25)' }} />}
								placeholder={msg}
								defaultValue={this.state.formNumber.number}
								onChange={(e) =>
									this.setState({
										formNumber: {
											...this.state.formNumber,
											number: e.target.value,
										},
									})
								}
							/>
						)}
					</FormattedMessage>,
				)}
			</Form.Item>
		);
	};

	renderCountryAndNationalSection = () => {
		const { getFieldDecorator } = this.props.form;

		return (
			<Row>
				<Col span={8}>
					<Form.Item style={{ marginBottom: 0 }}>
						{getFieldDecorator('country', {
							rules: [
								{
									required: false,
									message: <FormattedMessage id="form_msg_country" />,
								},
							],
						})(
							<FormattedMessage id="form_country">
								{(msg) => (
									<>
										<FormattedMessage id="form_country" />
										<ReactIntlTelInput
											inputProps={{
												placeholder: msg,
												style: {
													width: '100%',
													height: '32px',
													borderColor: 'rgba(217, 217, 217, 0.3)',
													borderRadius: 6,
													borderStyle: 'groove',
												},
											}}
											intlTelOpts={intlTelOpts}
											value={this.state.country_value}
											onChange={this.onChange}
										/>
									</>
								)}
							</FormattedMessage>,
						)}
					</Form.Item>
				</Col>
				<Col span={14}>
					<Form.Item style={{ marginBottom: 0 }}>
						{getFieldDecorator('is_national', {
							rules: [
								{
									required: false,
									message: <FormattedMessage id="form_msg_is_national" />,
								},
							],
						})(
							<div style={{ paddingLeft: 10 }}>
								<FormattedMessage id="form_is_national" />
								<Radio.Group
									defaultValue={this.state.formNumber.remove_cc > 0 ? '1' : '0'}
									buttonStyle="solid"
									onChange={(e) =>
										this.setState({
											formNumber: {
												...this.state.formNumber,
												remove_cc: e.target.value,
											},
										})
									}
									style={{ width: '100%' }}
								>
									<Radio.Button value="1">
										<FormattedMessage id="national" />
									</Radio.Button>
									<Radio.Button value="0">
										<FormattedMessage id="not_national" />
									</Radio.Button>
								</Radio.Group>
							</div>,
						)}
					</Form.Item>
				</Col>
			</Row>
		);
	};

	renderNumberInputSection = () => {
		if (this.state.showQRCode) {
			return this.renderQRCodeSection();
		}
		return this.renderPhoneNumberInput();
	};

	render() {
		const {
			form: { getFieldDecorator },
		} = this.props;
		return (
			<div>
				<Modal
					title={this.props.title}
					visible={this.props.visible}
					onCancel={this.onCancel}
					onOk={this.onOk}
					cancelText={<FormattedMessage id="cancel" />}
					footer={
						this.isAddDialogNumber() || (this.isAddMetaNumber() && !this.state.formNumber.id)
							? null
							: undefined
					}
					okButtonProps={{
						loading: this.props.number.loadingAddNumber,
						disabled: this.isOkDisabled(),
					}}
					style={{ top: 20 }}
					width={550}
				>
					{(!this.props.system.expired && !this.props.number.creationLimit) ||
					(!this.props.system.expired && this.state.formNumber.id) ? (
						<Form {...formItemLayout} onSubmit={this.handleSubmit} className="login-form">
							{!this.state.disableApiField && (
								<Form.Item style={{ marginBottom: 0 }}>
									{getFieldDecorator('api', {
										rules: [
											{
												required: false,
												message: <FormattedMessage id="form_msg_api" />,
											},
										],
									})(
										<FormattedMessage id="number_form_api">
											{(msg) => (
												<Select
													placeholder={msg}
													disabled={this.state.disableApiField}
													optionFilterProp="children"
													defaultValue={this.state.formNumber.api || msg}
													onChange={this.onApiChange}
													filterOption={(input, option) =>
														option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
													}
												>
													{this.props.number.apis.map(
														(api) =>
															!api.pro && (
																<Option key={api.id} value={api.id}>
																	{api.name}{' '}
																	{api.new === 1 && (
																		<Tag color="#87d068">
																			<FormattedMessage id="new" />
																		</Tag>
																	)}
																</Option>
															),
													)}
												</Select>
											)}
										</FormattedMessage>,
									)}
								</Form.Item>
							)}

							{!this.isAddDialogNumber() && !this.isAddMetaNumber() && !this.isEmptyApi() ? (
								<Form.Item style={{ marginBottom: 0 }}>
									{getFieldDecorator('nickname', {
										rules: [
											{
												message: 'The input is not valid E-mail!',
											},
											{
												required: false,
												message: <FormattedMessage id="form_msg_nickname" />,
											},
										],
									})(
										<FormattedMessage id="form_nickname">
											{(msg) => (
												<Input
													prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />}
													placeholder={msg}
													value={
														this.state.formNumber.nickname != null &&
														this.state.formNumber.nickname != undefined
															? this.state.formNumber.nickname
															: this.state.formNumber.name // Mostra o valor de "name" se o "nickname" não estiver definido
													}
													onChange={(e) => {
														this.setState({
															formNumber: {
																...this.state.formNumber,
																nickname: e.target.value, // Permite ao usuário deixar o campo vazio
															},
														});
													}}
												/>
											)}
										</FormattedMessage>,
									)}
								</Form.Item>
							) : null}

							{this.isAddDialogNumber() && (
								<div id="dialog-button">
									<Col type="flex" align="middle" className="mt-4">
										<DialogButton
											domain={this.props.number.infos.domain}
											label={<FormattedMessage id="add_new_number" />}
											style={{ width: '100%' }}
										/>
									</Col>
									<Col type="flex" align="middle" className="mt-4">
										<Button style={{ width: '100%' }} onClick={this.handleClick360Dialog}>
											<FormattedMessage id="help_360_dialog_49" />
										</Button>
									</Col>
								</div>
							)}

							{this.metaConnectionState() === 'disconnected' && (
								<Alert
									type="warning"
									showIcon
									message={<FormattedMessage id="meta_disconnected_alert_title" />}
									description={
										<span>
											<FormattedMessage id="meta_disconnected_alert_body" />{' '}
											<Button
												type="link"
												style={{ padding: 0 }}
												onClick={() => this.setState({ showIntegration: true })}
											>
												<FormattedMessage id="meta_disconnected_alert_cta" />
											</Button>
										</span>
									}
									style={{ marginBottom: 16 }}
								/>
							)}

							{this.isAddMetaNumber() && (
								<>
									{this.props.formNumber?.api !== 'meta' ? (
										!this.state.showIntegration ? (
											<MetaAccountSafety onNext={() => this.setState({ showIntegration: true })} />
										) : (
											<MetaIntegration
												formNumber={this.state.formNumber}
												onFinish={this.handleMetaFinish}
												label={
													this.state.formNumber.id ? (
														<FormattedMessage id="edit_number_meta" />
													) : (
														<FormattedMessage id="add_new_number" />
													)
												}
											/>
										)
									) : (
										this.state.showIntegration && (
											<MetaIntegration
												formNumber={this.state.formNumber}
												onFinish={this.handleMetaFinish}
												label={<FormattedMessage id="edit_number_meta" />}
											/>
										)
									)}
								</>
							)}

							{this.state.formNumber.api !== 'dialog' &&
								this.state.formNumber.api !== 'meta' &&
								!this.isEmptyApi() && (
									<div id="form-fields">
										{!this.state.showQRCode || useQRCode.includes(this.state.formNumber.api) ? (
											<Form.Item style={{ marginBottom: 0 }}>
												{getFieldDecorator('token', {
													rules: [
														{
															required: false,
															message: <FormattedMessage id="form_msg_token" />,
														},
													],
												})(
													<FormattedMessage id="form_token">
														{(msg) => (
															<Input
																disabled={useQRCode.includes(this.state.formNumber.api)}
																prefix={<Icon type="code" style={{ color: 'rgba(0,0,0,.25)' }} />}
																placeholder={msg}
																defaultValue={this.state.formNumber.token}
																onChange={(e) =>
																	this.setState({
																		formNumber: {
																			...this.state.formNumber,
																			token: e.target.value,
																		},
																	})
																}
															/>
														)}
													</FormattedMessage>,
												)}
											</Form.Item>
										) : null}

										{this.state.showDeviceId && !this.isEmptyApi() ? (
											<Form.Item style={{ marginBottom: 0 }}>
												{getFieldDecorator('account', {
													rules: [
														{
															required: false,
															message: <FormattedMessage id="form_msg_account" />,
														},
													],
												})(
													<FormattedMessage id="form_account">
														{(msg) => (
															<Input
																prefix={<Icon type="tag" style={{ color: 'rgba(0,0,0,.25)' }} />}
																placeholder={msg}
																defaultValue={this.state.formNumber.device_id}
																onChange={(e) =>
																	this.setState({
																		formNumber: {
																			...this.state.formNumber,
																			device_id: e.target.value,
																		},
																	})
																}
															/>
														)}
													</FormattedMessage>,
												)}
											</Form.Item>
										) : null}
										{this.state.showNamespace ? (
											<Form.Item style={{ marginBottom: 0 }}>
												{getFieldDecorator('namespace', {
													rules: [
														{
															required: false,
															message: <FormattedMessage id="form_msg_namespace" />,
														},
													],
												})(
													<FormattedMessage id="form_namespace">
														{(msg) => (
															<Input
																prefix={<Icon type="tag" style={{ color: 'rgba(0,0,0,.25)' }} />}
																placeholder={msg}
																defaultValue={this.state.formNumber.namespace}
																onChange={(e) =>
																	this.setState({
																		formNumber: {
																			...this.state.formNumber,
																			namespace: e.target.value,
																		},
																	})
																}
															/>
														)}
													</FormattedMessage>,
												)}
											</Form.Item>
										) : null}
										{this.renderCountryAndNationalSection()}
										{this.renderNumberInputSection()}
									</div>
								)}

							{(this.state.formNumber.api === 'dialog' ||
								this.state.showQRCode ||
								this.state.formNumber.api === 'meta') && (
								<Collapse ghost style={{ marginTop: '16px' }}>
									<Panel header={<FormattedMessage id="additional_settings" />} key="1">
										<Row style={{ display: 'flex', alignItems: 'center' }}>
											<Col span={12} height="100%">
												<FormattedMessage id="form_status" />
											</Col>
											<Col
												span={12}
												style={{
													display: 'flex',
													justifyContent: 'flex-end',
													alignItems: 'center',
													flexWrap: 'nowrap',
												}}
											>
												<Form.Item style={{ marginBottom: 0 }}>
													{getFieldDecorator('status', {
														initialValue: this.state.formNumber.status == 0 ? '0' : '1',
														rules: [
															{
																required: false,
																message: <FormattedMessage id="form_msg_status" />,
															},
														],
													})(
														<Radio.Group
															buttonStyle="solid"
															value={this.state.formNumber.status == 0 ? '0' : '1'}
															onChange={(e) =>
																this.setState({
																	formNumber: {
																		...this.state.formNumber,
																		status: e.target.value,
																	},
																})
															}
														>
															<Radio.Button
																value="1"
																style={{
																	fontSize: '12px',
																	width: '100px',
																	textAlign: 'center',
																	whiteSpace: 'nowrap',
																}}
															>
																<FormattedMessage id="online" />
															</Radio.Button>
															<Radio.Button
																value="0"
																style={{
																	fontSize: '12px',
																	width: '100px',
																	textAlign: 'center',
																	whiteSpace: 'nowrap',
																}}
															>
																<FormattedMessage id="offline" />
															</Radio.Button>
														</Radio.Group>,
													)}
												</Form.Item>
											</Col>
										</Row>
										<Row style={{ display: 'flex', alignItems: 'center' }}>
											<Col span={12} height="100%">
												<div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
													<FormattedMessage id="audio_transcription" />
													<Tooltip title={<FormattedMessage id="audio_transcription_tooltip" />}>
														<Icon
															type="question-circle"
															style={{
																color: '#1890ff',
																fontSize: '14px',
																cursor: 'help',
															}}
														/>
													</Tooltip>
													<Tag color="blue" style={{ fontSize: '12px' }}>
														<FormattedMessage id="new" />
													</Tag>
													{this.state.loadingOpenAISettings && (
														<Tooltip
															title={
																this.state.openaiRetryAttempt > 0
																	? `Tentativa ${this.state.openaiRetryAttempt} de 3`
																	: 'Carregando configurações...'
															}
														>
															<Icon type="loading" style={{ fontSize: '14px', color: '#1890ff' }} />
														</Tooltip>
													)}
												</div>
											</Col>
											<Col
												span={12}
												style={{
													display: 'flex',
													justifyContent: 'flex-end',
													alignItems: 'center',
													flexWrap: 'nowrap',
												}}
											>
												<Form.Item style={{ marginBottom: 0 }}>
													{getFieldDecorator('audio_transcription', {
														initialValue:
															String(this.state.formNumber.audio_transcription) === '1' ? '1' : '0',
														rules: [
															{
																required: false,
																message: <FormattedMessage id="form_msg_audio_transcription" />,
															},
														],
													})(
														<Radio.Group
															buttonStyle="solid"
															onChange={(e) => this.handleAudioTranscriptionChange(e.target.value)}
														>
															<Radio.Button
																value="1"
																style={{
																	fontSize: '12px',
																	width: '100px',
																	textAlign: 'center',
																	whiteSpace: 'nowrap',
																}}
															>
																<FormattedMessage id="enabled" />
															</Radio.Button>
															<Radio.Button
																value="0"
																style={{
																	fontSize: '12px',
																	width: '100px',
																	textAlign: 'center',
																	whiteSpace: 'nowrap',
																}}
															>
																<FormattedMessage id="disabled" />
															</Radio.Button>
														</Radio.Group>,
													)}
												</Form.Item>
											</Col>
										</Row>
										{String(this.state.formNumber.audio_transcription) === '1' && (
											<Row style={{ marginTop: '8px' }}>
												<Col span={24}>
													<Form.Item style={{ marginBottom: 0 }}>
														{getFieldDecorator('openai_token', {
															initialValue: this.state.formNumber.openai_token || '',
															rules: [
																{
																	required: false,
																	message: <FormattedMessage id="form_msg_openai_token" />,
																},
															],
														})(
															<FormattedMessage id="numbers_form_openai_token">
																{(msg) => (
																	<Input.Password
																		placeholder={msg}
																		value={this.state.formNumber.openai_token || ''}
																		loading={this.state.loadingOpenAISettings}
																		onChange={(e) => {
																			const newValue = e.target.value;
																			const currentValue = this.state.formNumber.openai_token || '';
																			const isActualChange =
																				newValue !== currentValue &&
																				!(newValue === '' && currentValue === '');

																			this.setState({
																				formNumber: {
																					...this.state.formNumber,
																					openai_token: newValue,
																				},
																				openaiTokenModified:
																					this.state.openaiTokenModified || isActualChange,
																			});
																		}}
																		style={{ width: '100%' }}
																		iconRender={(visible) =>
																			this.state.loadingOpenAISettings ? (
																				<Tooltip
																					title={
																						this.state.openaiRetryAttempt > 0
																							? `Tentativa ${this.state.openaiRetryAttempt} de 3`
																							: 'Carregando configurações...'
																					}
																				>
																					<Icon type="loading" />
																				</Tooltip>
																			) : (
																				<Icon type={visible ? 'eye' : 'eye-invisible'} />
																			)
																		}
																	/>
																)}
															</FormattedMessage>,
														)}
													</Form.Item>
												</Col>
											</Row>
										)}
									</Panel>
								</Collapse>
							)}
						</Form>
					) : this.props.system.expired && !this.props.number.creationLimit ? (
						<Alert
							message="Error"
							description={<FormattedMessage id="subscription_expired_msg" />}
							type="error"
							showIcon
						/>
					) : (
						this.props.number.creationLimit && (
							<Alert
								message="Error"
								description={<FormattedMessage id="subscription_limit_msg" />}
								type="error"
								showIcon
							/>
						)
					)}
				</Modal>
			</div>
		);
	}
}

const WrappedNumbersForm = Form.create({ name: 'numbers_form' })(AddEditNumberView);

export default ActiveConsumer(SystemConsumer(LanguageConsumer(NumberConsumer(WrappedNumbersForm))));
